import fauxSelect from '../../utils/faux-select.js';

function populateSelects() {
  fetch('/api/documents/documentlibraries?$filter=Title%20eq%20%27Documents%20by%20Plan%27&$select=Title,Id')
    .then((response) => response.json())
    .then((data) => {
      const myLibId = data.value[0].Id;
      const libDrop = document.getElementById('lib-select');
      const docDrop = document.getElementById('doc-select');
      const submit = document.getElementById('view-form-button');
      let folders = [];

      const requestDocs = (rootId) => {
        const formTrigger = document.querySelector('.document-select--form .document-select__trigger');
        const formTriggerText = formTrigger.querySelector('.value');

        fetch(`/api/documents/documents?$filter=FolderId eq ${rootId}`)
          .then((response) => response.json())
          .then((data) => {
            const documents = data.value;
            // empty doc dropdown
            docDrop.innerHTML = '';

            //populate dropdown with returned items.
            documents.forEach((document) => {
              docDrop.insertAdjacentHTML(
                'afterbegin',
                `<li><a href="#" class="doc-drop__item" data-href="${document.Url}">${document.Title}</a></li>`
              );
            });

            //add listener to set value of doc drop with href value
            docDrop.querySelectorAll('.doc-drop__item').forEach((docItem) => {
              docItem.addEventListener('click', function (e) {
                e.preventDefault();
                formTriggerText.removeAttribute('data-href');
                formTriggerText.setAttribute('data-href', docItem.getAttribute('data-href'));
                formTriggerText.textContent = docItem.textContent;
                formTrigger.click();
              });
            });
          });
      };

      let showError = () => {
        // write error functionality here.
        var errorMsg = document.querySelector('.document-select__error-message');
        errorMsg.classList.toggle('show');
      };

      //Get all folders with ID
      fetch(`/api/documents/folders?$filter=RootId%20eq%20${myLibId}&select=Title,Id,RootId`)
        .then((response) => response.json())
        .then((data) => {
          folders = data.value;

          //Iterate through folders
          folders.forEach((folder) => {
            libDrop.insertAdjacentHTML(
              'afterbegin',
              `<li><a href="#" class="document-select__list-item" data-root-id="${folder.Id}">${folder.Title}</a></li>`
            );
          });
        })
        .then(() => {
          //add event listener to folder buttons
          const libDropItems = libDrop.querySelectorAll('.document-select__list-item');
          const libDropFolders = [].slice.call(libDropItems);

          libDropFolders.forEach((item) => {
            const rootId = item.getAttribute('data-root-id');
            item.addEventListener('click', function () {
              requestDocs(rootId);
            });
          });

          fauxSelect($('.document-select--cat'));
        });

      //set submit functionality to drive user
      submit.addEventListener('click', function () {
        const docUrl = document
          .querySelector('.document-select--form .document-select__trigger .value')
          .getAttribute('data-href');

        if (docUrl) {
          window.location.assign(docUrl);
        } else {
          showError();
        }
      });

      //Apply Faux Select to dropdowns
      fauxSelect($('.document-select--form'));
    })
    .catch((error) => {
      console.log('There was an error fetching the data', error);
    });
}

populateSelects();
